import React from 'react';
import { ActivityIndicator, StyleSheet, Text } from 'react-native';
import { Image, ListItem } from '@rneui/themed';

import { useLanguage } from 'context/LanguageContext';
import { type TableType } from 'types/Table';

const styles = StyleSheet.create({
  image: {
    aspectRatio: 1,
    width: '80%',
    justifyContent: 'center',
  },
});

interface Props {
  item: TableType;
}

const resolveLocalizedText = (
  value: unknown,
  currentLanguage: string
): string => {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    const localizedValue = (value as Record<string, string>)[currentLanguage];
    if (localizedValue) {
      return localizedValue;
    }

    const fallback = (value as Record<string, string>)['en'];
    if (fallback) {
      return fallback;
    }

    const first = Object.values(value as Record<string, string>)[0];
    if (typeof first === 'string') {
      return first;
    }
  }

  return String(value);
};

const Item: React.FC<Props> = ({ item }) => {
  const { currentLanguage } = useLanguage();
  return (
    <>
      <ListItem.Title>
        <Text>{resolveLocalizedText(item.name, currentLanguage)}</Text>
      </ListItem.Title>
      {item.description ? (
        <ListItem.Subtitle>
          <Text>{resolveLocalizedText(item.description, currentLanguage)}</Text>
        </ListItem.Subtitle>
      ) : null}
      {item.image ? (
        <Image
          source={{ uri: item.image }}
          containerStyle={styles.image}
          PlaceholderContent={<ActivityIndicator />}
        />
      ) : null}
    </>
  );
};

export default Item;
